export default class PlacesController extends Controller {
  static targets = ['field'];

  connect() {
    document.addEventListener('turbo:load', this.initializePlaces.bind(this));
  }

  disconnect() {
    document.removeEventListener('turbo:load', this.initializePlaces.bind(this));
  }

  initializePlaces() {
    if (typeof google !== 'undefined' && this.hasFieldTarget) {
      this.initMap();
    }
  }

  initMap() {
    try {
      this.autocomplete = new google.maps.places.Autocomplete(this.fieldTarget, {
        types: this.options.types,
      });
    } catch (error) {
      console.error('Error initializing Google Places Autocomplete:', error);
    }
  }

  get options() {
    return JSON.parse(this.fieldTarget.dataset.options);
  }
}
